'use client';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import { copyColor, copyFontFamily, copyFontSizeSmall, formInputBackgroundColor, formBorderColor, formBorderColorValid, formBorderColorInvalid, standardFocusStyleDeclarations } from '@nib-components/theme';
import { breakpoint, p, pr } from '@nib/layout';
const disabledCursor = 'not-allowed';
const disabledOpacity = 0.5;
const validFormModes = ['light', 'white'];
const StyledTextarea = styled.textarea`
  display: block;
  box-sizing: border-box;
  width: 100%;
  resize: vertical;
  ${p(2)};
  ${breakpoint('mini')`
    ${p(4)};
    /* Non-standard padding to accommodate validation icon */
    padding-inline-end: 3.5rem;
  `}
  /* Non-standard padding to accommodate validation icon */
  padding-right: 3.5rem;
  background-color: var(--inputColorBg, ${formInputBackgroundColor});
  color: var(--themeColorFg, ${copyColor});
  font-size: 1rem;
  font-family: ${copyFontFamily};
  line-height: 1.5;
  height: 10em;
  border: 0;
  box-shadow: inset 0 -2px 0 0 var(--inputColorBorder, ${formBorderColor});
  border-radius: 0;

  &::-ms-clear {
    display: none;
  }
  appearance: none;

  ${_ref => {
  let {
    isCompact
  } = _ref;
  return isCompact && css`
      &&& {
        display: inline-block;
        ${p(2)};
        ${pr(6)};
        font-size: ${copyFontSizeSmall};
      }
    `;
}};

  ${_ref2 => {
  let {
    disabled
  } = _ref2;
  return disabled && css`
      opacity: ${disabledOpacity};
      cursor: ${disabledCursor};
    `;
}}

  /* Validated and invalid */
  ${_ref3 => {
  let {
    valid,
    validated
  } = _ref3;
  return !valid && validated && css`
      box-shadow: inset 0 0 0 2px var(--themeColorBorderError, ${formBorderColorInvalid});
    `;
}}

  /* Validated and valid */
  ${_ref4 => {
  let {
    valid,
    validated
  } = _ref4;
  return valid && validated && css`
      box-shadow: inset 0 -2px 0 0 var(--themeColorBorderSuccess, ${formBorderColorValid});
    `;
}}

  &:focus-visible {
    ${standardFocusStyleDeclarations};
  }
`;
var _React_Component;
class Textarea extends (_React_Component = React.Component) {
  render() {
    const {
      disabled,
      valid = false,
      validated = false,
      formMode,
      ...otherProps
    } = this.props;
    return /*#__PURE__*/_jsx(StyledTextarea, {
      ...otherProps,
      ref: input => this.input = input,
      disabled: disabled,
      valid: valid,
      validated: validated,
      formMode: formMode,
      "data-mesh-component": "TEXTAREA"
    });
  }
  constructor() {
    super(...arguments), _define_property(this, "input", null);
  }
}
_define_property(Textarea, "displayName", 'Textarea');
export default Textarea;